/**
 * React Query Keys
 * Centralized query keys to avoid duplicates
 */
export const QUERY_KEYS = {
  USER: "user",
  DASHBOARD: "dashboard",
  ORDERS: "orders",
  PROFILE: "profile",
  PROPERTIES: "properties",
  PROPERTY_DETAILS: "property-details",
} as const;
